<template>
  <v-app id="inspire">
    <v-content>
      <v-container class="fill-height" fluid>
        <v-row align="center" justify="center">
          <v-col cols="12" sm="8" md="4">
            <v-card class="elevation-12">
              <v-toolbar color="primary" dark flat>
                <v-toolbar-title>{{ $t("heading.login") }}</v-toolbar-title>
              </v-toolbar>
              <v-card-text>
                <v-form @submit.prevent="handleLogin">
                  <form-group
                    name="email"
                    :validator="$v.email"
                    attribute="fields.email"
                  >
                    <template slot-scope="{ attrs }">
                      <v-text-field
                        v-bind="attrs"
                        v-model="email"
                        @input="$v.email.$touch()"
                        type="email"
                        outlined
                        :append-icon="'mdi-email'"
                      >
                      </v-text-field>
                    </template>
                  </form-group>

                  <form-group
                    name="password"
                    :validator="$v.password"
                    attribute="fields.password"
                  >
                    <template slot-scope="{ attrs }">
                      <v-text-field
                        v-bind="attrs"
                        v-model="password"
                        @input="$v.password.$touch()"
                        outlined
                        :type="showPassword ? 'text' : 'password'"
                        :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                        @click:append="showPassword = !showPassword"
                      >
                      </v-text-field>
                    </template>
                  </form-group>
                  <v-card-actions>
                    <div class="flex-grow-1"></div>
                    <v-btn
                      block
                      :loading="loading"
                      color="primary"
                      type="submit"
                    >
                      {{ $t("form_box.login") }}</v-btn
                    >
                  </v-card-actions>
                </v-form>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
import { validationMixin } from "vuelidate";
import { required, minLength, email } from "vuelidate/lib/validators";

export default {
  mixins: [validationMixin],
  validations: {
    email: { required, email },
    password: {
      required,
      minLength: minLength(6)
    }
  },
  watch: {
    $route: {
      handler: function(route) {
        this.redirect = route.query && route.query.redirect;
      },
      immediate: true
    }
  },
  data() {
    return {
      loading: false,
      email: "",
      password: "",
      loading: false,
      redirect: undefined,
      showPassword: false
    };
  },
  methods: {
    handleLogin() {
      if (this.$v.$invalid) {
        return;
      } else {
        this.loading = true;

        let data = {
          username: this.email,
          password: this.password
        };
        this.$store
          .dispatch("LoginByEmail", data)
          .then(() => {
            this.loading = false;
            this.$router.push({ path: this.redirect || "/" });
          })
          .finally(() => {
            this.loading = false;
          });
      }
    }
  }
};
</script>
